
  import gql from 'graphql-tag';
  import insuranceCompanyQuery from '~/apollo/queries/insurance-company/insuranceCompanies.gql'
  import insurerPageCategoryQuery from '~/apollo/queries/insurance-company/insurerPageCategory.gql'
  import insuranceCompanyPageQuery from '~/apollo/queries/insurance-company/insuranceCompanyPages.gql'
  import processImageLink from '~/mixins/processImageLink.js';
  import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
  import eventTrackingInsurerPageMixins from '~/mixins/eventTrackingInsurerPageMixins.js'

  export default {
    name: 'InsuranceCompanyPage',
    mixins: [processImageLink, eventTrackingMixins, eventTrackingInsurerPageMixins],
    data() {
      return {
        insuranceCompanies: null,
        loading: 0,
        code: this.$route.params.code.toUpperCase(),
        cat: this.$route.params.cat,
        currentLocale: this.$normalizeLocale(this.$i18n.locale),
        insuranceCompanyPages: null,
        insurerPageCategories: null
      };
    },

    head() {
      if (!this.loading) {
          const trans = this.insuranceCompanyPages[0]?.InsuranceCategories.filter((item) => item?.CategoryName == this.$route.params.cat)
          if (trans) {
            let pageMeta;
            if (trans[0]?.insurer_page_trans[0]?.locale == this.$normalizeLocale(this.$i18n.locale)) {
              pageMeta = trans[0]?.insurer_page_trans[0];
            } else {
              this.$router.push({
                    path: `/${this.$i18n.locale}/404/`
                  })
              pageMeta = trans[0]?.insurer_page_trans[0]?.localizations[0];
            }

            return {
              title: pageMeta?.PageMeta?.Title,
              meta: [
                {
                  hid: 'og:title', name: 'og:title', property: 'og:title',
                  content: pageMeta?.PageMeta?.Title,
                },
                {
                  hid: 'og:description', name: 'og:description', property: 'og:description',
                  content: pageMeta?.PageMeta?.Description,
                },
                {
                  hid: 'description', name: 'description',
                  content: pageMeta?.PageMeta?.Description,
                },
                {
                  hid: 'og:image', name: 'og:image', property: 'og:image',
                  content: pageMeta?.PageMeta?.Image?.url,
                },
              ]
            }
        } else {
          this.$router.push({
            path: `/${this.$i18n.locale}/404/`
          })
        }
      }
      return null;
    },
    apollo: {
      $loadingKey: 'loading',
      insuranceCompanies: {
        query: gql`
          ${insuranceCompanyQuery}
        `,
        prefetch: true,
        variables() {
          return {
            code: this.code,
            locale: this.currentLocale,
          };
        },
        update(data) {
          return this.$normalizeStrapi(data.insuranceCompanies.data);
        },
      },
      insuranceCompanyPages: {
        query: gql`
          ${insuranceCompanyPageQuery}
        `,
        prefetch: true,
        variables() {
          return {
            code: this.code,
            locale: this.currentLocale,
          };
        },
        update(data) {
          return this.$normalizeStrapi(data.insuranceCompanyPages.data);
        },
        result({ data }) {
          if(data?.insuranceCompanyPages?.data.length){
            const cats = data?.insuranceCompanyPages?.data[0]?.attributes?.InsuranceCategories;
            if(cats.length>0)
            {
              const currentCat = cats.filter((item)=>item.CategoryName===this.cat);
              if (currentCat.length === 0) {
                this.$router.push({
                  path: `/${this.$i18n.locale}/404/`
                })
                // return this.$nuxt.error({ statusCode: 404, message: "Page Not Found" })
              }
              // if(currentCat.length===0)
              // {
              //   this.$router?.push(
              //     {
              //       path: `/${this.$i18n.locale}/insurer/`+this.code+'/'
              //     }
              //   )
              // }
            }
            else
            {
              this.$router?.push({
                path: `/${this.$i18n.locale}/insurer/`+this.code+'/'
              })
            }
          }
          else
          {
            this.$router?.push({
              path: `/${this.$i18n.locale}/insurer/`+this.code+'/'
            })
          }
        },
      },
      insurerPageCategories: {
        query: gql`
          ${insurerPageCategoryQuery}
        `,
        prefetch: true,
        variables() {
          return {
            locale: this.currentLocale,
          };
        },
        update(data) {
          return this.$normalizeStrapi(data.insurerPageCategory.data);
        },
      },
    },
    computed: {
      category(){
        if (this.insuranceCompanyPages[0]?.InsuranceCategories == null) {
          return null;
        }
        const cat = this.insuranceCompanyPages[0]?.InsuranceCategories.filter((item) => item.CategoryName === this.$route.params.cat)
        if(cat.length > 0)
        {
          return cat[0]
        }
        return null;
      },

      insurerPageDetail() {
        if (!this.loading) {
          if (this.category !== null) {
            const trans = this.category.insurer_page_trans[0];
            if (trans !== null) {
                if(trans.locale===this.$normalizeLocale(this.$i18n.locale))
                {
                  return trans;
                }
                else
                {
                  return trans.localizations[0]
                }
              }
            }
            return null;
        }
      },
      isZhHK() {
        if (this.$i18n.locale == 'zh-HK') {
          return true;
        }
        return false;
      }
    }
  }
